const state = {
  // 侧边栏状态
  sidebar: {
    opened: true,
    withoutAnimation: false
  },
  // 设备类型
  device: 'desktop',
  // 加载状态
  loading: false,
  // 主题变更key，用于强制组件重新渲染
  themeChangeKey: 0
};

const mutations = {
  TOGGLE_SIDEBAR: (state) => {
    if (document.body.clientWidth <= 768) {
      state.sidebar.opened = !state.sidebar.opened;
      state.sidebar.withoutAnimation = false;
    } else {
      state.sidebar.opened = !state.sidebar.opened;
      state.sidebar.withoutAnimation = true;
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device;
  },
  SET_LOADING: (state, loading) => {
    state.loading = loading;
  },
  // 触发主题变更，递增key以强制组件重新渲染
  TRIGGER_THEME_CHANGE: (state) => {
    state.themeChangeKey++;
  }
};

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR');
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation);
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device);
  },
  setLoading({ commit }, loading) {
    commit('SET_LOADING', loading);
  },
  // 触发主题变更通知
  triggerThemeChange({ commit }) {
    commit('TRIGGER_THEME_CHANGE');
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
